import * as z from 'zod';
import { ReservationItemResource } from '@/types/reservations/ReservationItem';
/** A reservable that is still checked in on another reservation item, which has to be checked out first. */
export const ReservableInUse = z.object({
    reservable_id: z.number(),
    reservable_identifier: z.string(),
    /** The reservation item that has the reservable checked in */
    reservation_item_id: z.number().nullable(),
    reservation_id: z.number().nullable(),
    reservation_number: z.string().nullable(),
    /** When the reservation holding it ended or ends */
    return_date_time: z.string().nullable()
});
/** What came of checking an item in, from POST reservation-items/{id}/mark-delivered */
export const CheckInItemResponse = z.discriminatedUnion('outcome', [
    z.object({
        outcome: z.literal('checked_in'),
        reservation_item: ReservationItemResource,
        checkin_confirmation_sent: z.boolean()
    }),
    z.object({
        outcome: z.literal('already_checked_in'),
        reservation_item: ReservationItemResource
    }),
    z.object({
        outcome: z.literal('reservable_in_use'),
        reservable_in_use: ReservableInUse
    })
]);
export const CheckInItemResult = CheckInItemResponse.transform((data) => {
    switch (data.outcome) {
        case 'checked_in':
            return { outcome: data.outcome, item: data.reservation_item, checkinConfirmationSent: data.checkin_confirmation_sent };
        case 'already_checked_in':
            return { outcome: data.outcome, item: data.reservation_item, checkinConfirmationSent: false };
        case 'reservable_in_use':
            return { outcome: data.outcome, reservableInUse: data.reservable_in_use };
    }
});
